import React from 'react';

const WalletConnection = ({ isConnected, walletAddress, onConnect, onDisconnect }) => {
  const handleConnect = async () => {
    // Replace with actual Web3 wallet connection
    if (window.ethereum) {
      try {
        const accounts = await window.ethereum.request({ 
          method: 'eth_requestAccounts' 
        });
        onConnect(accounts[0]);
      } catch (error) {
        console.error("Error connecting to wallet:", error);
      }
    } else {
      // For testing, we'll simulate with a fake address
      onConnect("0x1234...5678");
      alert("No Ethereum wallet detected. Using simulated wallet for demo purposes.");
    }
  };

  const handleDisconnect = () => {
    onDisconnect();
  };

  const formatAddress = (address) => {
    if (!address) return "";
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  return (
    <div>
      {isConnected ? (
        <div className="wallet-status">
          <span className="wallet-indicator"></span>
          <span className="wallet-address">{formatAddress(walletAddress)}</span>
          <button 
            onClick={handleDisconnect}
            className="connect-wallet"
          >
            Disconnect
          </button>
        </div>
      ) : (
        <button 
          onClick={handleConnect}
          className="connect-wallet"
        >
          Connect Wallet
        </button>
      )}
    </div>
  );
};

export default WalletConnection;